var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashBoardCheckList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5496 0.259277H40.5172C49.8886 0.259277 56.1638 6.8386 56.1638 16.6247V39.2128C56.1638 48.9684 49.8886 55.5477 40.5172 55.5477H16.5496C7.17825 55.5477 0.875366 48.9684 0.875366 39.2128V16.6247C0.875366 6.8386 7.17825 0.259277 16.5496 0.259277ZM26.9439 36.1691L40.0749 23.0381C41.0148 22.0982 41.0148 20.5778 40.0749 19.6102C39.135 18.6703 37.5869 18.6703 36.647 19.6102L25.2299 31.0273L20.3922 26.1896C19.4523 25.2497 17.9042 25.2497 16.9643 26.1896C16.0244 27.1295 16.0244 28.6499 16.9643 29.6174L23.5436 36.1691C24.0136 36.6391 24.6218 36.8602 25.2299 36.8602C25.8658 36.8602 26.4739 36.6391 26.9439 36.1691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardCheckList);
export default __webpack_public_path__ + "static/media/dashBoard-checkList.51f83e0c2594a4e651088119f6a9aea9.svg";
export { ForwardRef as ReactComponent };